import type { ComponentPropsWithoutRef } from 'react';

import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import type { AiActionType } from '@/utils/hooks/context/scheduler/types';

import Icon from '@/components/base/Icon';
//components
import { GenerationPlaceholder } from '@/components/composite/Scheduler/PostFunnel/SchedulerCaption/GenerationPlaceholder';

function CaptionPlaceholderFooter() {
    return (
        <div className={clsx('flex w-full items-center justify-end gap-2')}>
            <div className="flex items-center divide-x divide-icoGray-300 text-xl text-icoGray-500 dark:divide-icoDarkMode-beton dark:text-icoDarkMode-wolf">
                <div className="flex items-center gap-x-5 pr-5">
                    <Icon icon="hashtag" />
                    <Icon icon="captions" />
                </div>
                <Icon icon="engagement" className="pl-5" />
            </div>
        </div>
    );
}

function CaptionPlaceholderWrapper({ children }: ComponentPropsWithoutRef<'div'>) {
    return (
        <div className="z-0 flex min-h-[248px] w-full flex-col justify-between rounded-md border-0 px-8 pb-5 pt-8 ring-1 ring-icoGray-400 dark:ring-icoDarkMode-beton">
            {children}
        </div>
    );
}

export function CaptionRendering({
    children,
    currentAction,
    error
}: ComponentPropsWithoutRef<'div'> & { currentAction: AiActionType; error: string }) {
    const { t } = useTranslation('scheduler');

    function getTranslationToken() {
        if (currentAction === 'changing_tone') {
            return 'scheduler_funnel.ai_caption.loading.changing_tone';
        }
        if (currentAction === 'enhancing') {
            return 'scheduler_funnel.ai_caption.loading.enhancing';
        }
        if (currentAction === 'translating') {
            return 'scheduler_funnel.ai_caption.loading.translating';
        }

        return 'scheduler_funnel.ai_caption.loading.generating_hashtags';
    }

    if (currentAction) {
        return (
            <CaptionPlaceholderWrapper>
                <div className="w-full rounded-md bg-icoGray-100 p-3 dark:bg-icoDarkMode-deepBlack">
                    <GenerationPlaceholder placeholderText={t(getTranslationToken())} />
                </div>
                <CaptionPlaceholderFooter />
            </CaptionPlaceholderWrapper>
        );
    }

    return (
        <div className="flex flex-col space-y-2">
            {children}
            {error ? <span className="text-xxs text-icoRed">{error}</span> : null}
        </div>
    );
}
